import React, { useState } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";

import homeabout from "../assets/new-images/about.webp";
import whychooseus from "../assets/new-images/why_home.webp";
import Services from "../components/Services";
import Contactform from "../components/Contactform";
import AOS from "aos";
import { Link } from "react-router-dom";
import Banner from "../components/Banner";
AOS.init();
const Home = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div>
      {/* <Popup /> */}
      <div className="home-banner">
        <Container>
          <Row>
            <Col xs={{ span: 12, order: 2 }} md={{ span: 7, order: 1 }}>
              <div className="banner-content">
                <h1>Empower your employees to travel safe and smart!</h1>
                <p className="banner-subtitle">Your trusted partner in safe, reliable corporate mobility.</p>
                <p>
                 Hive Employee Transportation and Cab Services is one of the leading transportation service providers, catering to all the transportation demands of corporates and individuals, thereby ensuring the utmost safety and comfort. Our vehicles are clean, well-maintained, and comply with all rules and regulations. Not only this, we value your time and thus strive to follow the shortest and most comfortable routes, with a mobile application enabled for tracking. We do everything to ensure satisfaction and a pleasant experience for your employees.
                </p>
                <div className="banner-cta-wrap">
                  <Button className="primary-btn banner-cta-primary" onClick={handleShow}>
                    Book Now
                  </Button>
                  <Link to="/contact-us" className="banner-cta-secondary">
                    Contact Us
                  </Link>
                </div>
                <Modal size="lg" show={show} onHide={handleClose} centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Book Now</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Contactform />
                  </Modal.Body>
                </Modal>
              </div>
            </Col>
            <Col xs={{ span: 12, order: 1 }} md={{ span: 5, order: 2 }}>
              <Banner/>
            </Col>
          </Row>
        </Container>
      </div>
      
      <div className="home-about">
        <Container>
          <Row className="gx-5">
            <Col xs={12} md={7} data-aos="fade-right">
              <h5>Who We Are</h5>
              <p>
                At Hive Employee Transportation And Cab Services, we're more than just a Corporate
                Mobility Company; we're your trusted partner in seamless
                transportation solutions. With a robust fleet of 80+ Cabs and a
                dedicated team of 100 Chauffeurs, we cater to the diverse needs
                of 10+ esteemed Clients across Hyderabad.
              </p>
              <p>
                Since our establishment in 2004, Hive Employee Transportation And Cab Services has been
                synonymous with excellence. Our growth trajectory is a testament
                to our unwavering commitment to exceptional service,
                industry-leading processes, and continuous technological
                innovation.
              </p>
              <p>
                From Economy Sedans to Luxury Cars and Coaches, Hive Employee Transportation And Cab Services a comprehensive range of car rental services
                tailored to your specific requirements.
              </p>
              <p>
                What sets us apart is our focus on client satisfaction and
                chauffeur well-being. With 67% of our Chauffeurs and 81% of our
                Clients choosing to stay with us for over a decade, we take
                pride in our reputation for reliability and excellence.
              </p>
              <p>
                Our aim is simple: to be your preferred choice for corporate
                mobility, delivering unmatched service and value every step of
                the way.
              </p>
              <Link to="/about-us">
                <Button className="primary-btn">Read More</Button>
              </Link>
            </Col>
            <Col xs={12} md={5} data-aos="fade-left">
              <img
                src={homeabout}
                className="img-fluid img-animation mt-3"
                alt="logo"
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="home-about bg-light">
        <Container>
          <Row className="gx-5">
            <Col xs={12} md={5}  data-aos="fade-right">
              <img
                src={whychooseus}
                className="img-fluid img-animation"
                alt="logo"
              />
            </Col>
            <Col xs={12} md={7} data-aos="fade-left">
              <div className="service-content pt-20">
                <h5>Why Choose Hive Employee Transportation And Cab Services</h5>
                <h6>End-to-End Mobility Solution</h6>
                <p>
                  At Hive Employee Transportation And Cab Services, we provide comprehensive end-to-end
                  mobility solutions tailored to meet all your travel needs.
                  From car rentals and air tickets to hotel bookings and holiday
                  packages, we offer a seamless integration of services, all
                  intricately woven together through advanced technology.
                </p>
                <p>
                  With us, managing your travel requirements is effortless and
                  hassle-free. Our cutting-edge technology ensures smooth
                  coordination and efficient handling of every aspect of your
                  journey.
                </p>
                <p>
                  Experience exceptional customer service and satisfaction as we
                  deliver top-notch mobility solutions across India. Choose Hive Employee Transportation And Cab Services for a travel experience that exceeds
                  expectations.
                </p>
                <Link to="/about-us">
                  <Button className="primary-btn">Read More</Button>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Services />
      
      
    </div>
  );
};

export default Home;
